import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ModalLogo from '../../../assets/images/modal_logo.png';
// import Modal from '../Modal';
import { useKeyDown } from '../../../hooks/useKeyDown';
import SecureIcon from '../../../assets/images/Error.png';
import Arrow from '../../../assets/kudzu-plus-images/arrow-image.png';
import backArrow from '../../../assets/kudzu-plus-images/comparisonBackArrow.png';
import buttonBorder from '../../../assets/kudzu-plus-images/gradient-button-square.png';
import closeIcon from '../../../assets/kudzu-plus-images/Close-kudzu-plus.png';
import Reasonchecked from '../../../assets/kudzu-plus-images/reasonchecked.png'
import Oops from '../../../assets/kudzu-plus-images/Oops.png'
import CustomTextArea from '../../../components/CustomComponents/CustomTextArea';

import 'animate.css';
import { displayErrorMessage } from '../../../utils';
import comparisonClose from '../../../assets/kudzu-plus-images/comparison-close.png'

const CustomModalPlus = (props) => {
    const { isOpen, onClose, onBack, highlightMsg, HeaderMsg,subHeadingForCarousel, fullWidth, footerButtonEnable, gradientButton, gradientBtnBackground, borderGradientrouneded, skipAndNextButtonsEnable, allButtonsDisable,
        subHeaderMsg, image, carousel, opacityLow, summaryParagraph, btn1Exists, btn2Exists, btn1Text, btn2Text, imageMargin,
        btn1TypeAcpt, footerMsg, onAcptBtnClick, borderWhite, comparisonScreen, subFooter, onCancelBtnClick, isBorderNone, Fullheight, textMessage, isSubComponent, subComponent, defaultCornerRadius = true, isIframe = false, isDownCancelReason, onchangeTextCancelText, isDownCancelReasonComments, CommnetsValidationError,footerText,gradientBtnCheckExtend} = props

    const { t } = useTranslation(); // Hook to access translation functions
    const HeadingStyles = "font-serif-pro modal-title sm:text-[18px] md:text-[32px] text-[25px] sm:leading-[24px] md:leading-[38px] leading-[31px] font-normal text-[#2965FB]";
    const SubHeadingStyles = "font-serif-pro modal-title sm:text-[18px] md:text-[32px] text-[20px] sm:leading-[24px] md:leading-[38px] leading-[31px] font-normal";


    const modalRef = useRef(null);
    const btn1Ref = useRef(null);
    const btn1AccRef = useRef(null);
    const btn2Ref = useRef(null);
    const [currentFocus, setCurrentFocus] = useState('');
    const [comments, setComments] = useState('');
    // const [CommnetsValidationError, setCommnetsValidationError] = useState('');
    const [isShowTextArea, setIsShowTextArea] = useState('');


    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (event.target.classList.contains('modal')) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('click', handleOutsideClick);
        }

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isOpen, onClose]);


    const handleReceivedText = (receivedText) => {
        setComments(receivedText);
    }

   



    useEffect(() => {
        if (isOpen && modalRef.current) {
            modalRef.current.classList.add('animate__animated', 'animate__fadeInUpBig');
        } else if (modalRef.current) {
            modalRef.current.classList.remove('fade-in');
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }




    const handleClose = () => {
        modalRef.current.classList.remove('animate__fadeInUpBig');
        modalRef.current.classList.add('animate__fadeOutDown');
        setTimeout(() => {
            onClose();
        }, 500); // Adjust the timeout duration as needed
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center overflow-y-auto " style={{ zIndex: props.zIndex ? props.zIndex : 100 }}>

            <div className=' absolute top-0 left-0 flex w-full items-center justify-center'>
                <div className={`modal-overlay fixed inset-0 bg-[var(--kudzu-plus-card-bg)] ${opacityLow ? "opacity-60" : "opacity-100"} transition-opacity`} />
                <div
                    ref={modalRef} style={{ overflowY: 'auto', backgroundColor: '#262B3A' }}
                    className={`modal-container bg-[#262B3A] ${props?.modalBg ? props?.modalBg : 'bg-card'} absolute sm:top-24 top-0 ${defaultCornerRadius ? 'sm:rounded-tl-card-tr sm:rounded-br-card-bl' : fullWidth ? 'sm:rounded-tr-card-tr' : 'sm:rounded-tr-[4rem] sm:rounded-bl-[4rem]'}  md:w-[778px] sm:w-[466px] w-[100%] mx-auto shadow-lg z-50 transition-all duration-300 ease-in-out h-[100vh] sm:h-fit`}
                // className="modal-container bg-[#262B3A] bg-card absolute sm:top-24 top-0 sm:rounded-tl-card-tr sm:rounded-br-card-bl md:w-[778px] sm:w-[466px] w-[100%] mx-auto shadow-lg z-50 transition-all duration-300 ease-in-out h-[100vh] sm:h-fit"    
                >
                    <div className="modal-content text-left">
                        {/* <div className={`modal-body  h-[100%] ${isIframe ? 'flex justify-center' : 'flex sm:justify-center items-center'} flex-col sm:mt-[60px] md:mt-[110px] mt-[68px] mb-[30px]`}> */}
                        <div className={`modal-body  h-[100%] ${fullWidth ? 'flex justify-center' : 'flex sm:justify-center items-center'} flex-col sm:mt-[60px] md:mt-[76px] mt-[68px] ${fullWidth ? "" : 'mb-[30px]'}`}>
                            <div className={` ${fullWidth ? 'w-[100%]' : 'md:w-[450px] sm:w-[294px] xsm:w-[240px] w-[240px]'} `}>
                                <div className='w-full flex flex-col items-center self-center mt-3 '>
                                    {comparisonScreen &&
                                        <span
                                            className='absolute md:top-[60px] sm:top-[44px] top-[30px] left-[30px] sm:left-[50px]'
                                            tabIndex={0}
                                            // onKeyDown={(event) => {
                                            //     if (event.key === "Enter") {
                                            //         event.preventDefault();
                                            //         onClose();
                                            //     }
                                            // }}
                                            // onClick={(event) => {
                                            //     event.target.style.opacity = 0.8;
                                            //     onClose(); setTimeout(() => { event.target.style.opacity = 1; },
                                            //         200);
                                            // }}
                                            
                                            >
                                            <button className="modal-close text-[16px] font-[600] text-[#779CE5] cursor-pointer flex items-center gap-[8px]" onClick={onBack} >

                                                <img
                                                    src={backArrow}
                                                    className="md:w-[8px] sm:w-[11px] md:h-[14px] sm:h-[13px] w-[8px] ml-1"
                                                    alt="" />
                                                Back
                                            </button>
                                        </span>}

                                    <span
                                        className={`${fullWidth ? 'md:block' : ""} absolute md:top-[60px] sm:top-[44px] top-[30px] right-[30px] sm:right-[50px]`}
                                        tabIndex={0}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                onClose();
                                            }
                                        }}
                                        onClick={(event) => {
                                            event.target.style.opacity = 0.8;
                                            onClose(); setTimeout(() => { event.target.style.opacity = 1; },
                                                200);
                                        }}>
                                        <button className="modal-close text-gray-500 hover:text-gray-800 h-[13px] w-[13px] 
                                 cursor-pointer" >
                                            <img src={comparisonScreen ? comparisonClose  : closeIcon} alt='' className='opacity-50' />
                                            {/* <svg xmlns="http://www.w3.org/2000/svg"
                                                className="h-[1rem] w-[1rem] opacity-[60%]"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor" >
                                                <path strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg> */}
                                           
                                        </button>
                                    </span>
                                    <div className='md:w-[450px] sm:w-[294px] xsm:w-[240px] w-[240px]'>
                                        {highlightMsg}
                                        {HeaderMsg}
                                    </div>
                                   {subHeadingForCarousel &&
                                     <div className='md:w-[450px] sm:w-[294px] xsm:w-[240px] w-[240px]'>
                                        {subHeadingForCarousel}
                                    </div>}
                                    {comparisonScreen &&
                                        <div className='w-full'>
                                            {comparisonScreen && (<div>{comparisonScreen}</div>)}
                                        </div>
                                    }
                                    {fullWidth ? "" : <div className='md:w-[450px] sm:w-[294px] xsm:w-[240px] w-[240px] flex flex-col justify-start gap-4 '>
                                        {subHeaderMsg && <div className='w-full flex flex-row'>
                                            <div>
                                                {props?.showErrorImg && <img src={SecureIcon} alt='SecureIcon' className='mr-[1.1rem] w-[13px] mt-1' />}
                                            </div> {subHeaderMsg}
                                        </div>}
                                        {textMessage &&
                                            <div className='w-full'>

                                                {textMessage && (<div>{textMessage}</div>)}
                                            </div>
                                        }
                                        {isSubComponent &&
                                            <div className='w-full'>
                                                {subComponent}
                                            </div>
                                        }
                                        {image && (
                                            <div className={`w-full mt-12 mb-14 flex flex-col items-center ${props?.imageMargin ? props?.imageMargin : ''}`}>
                                                <img
                                                    src={image}
                                                    className={props?.largeImage ? 'w-[200px] h-[150px]' : `lg:w-[180px] lg:h-[150px] md:w-[350px] 
                                           md:h-[350px] sm:w-[92px] sm:h-[92px] w-[300px] h-[350px]`} alt=''
                                                />
                                            </div>
                                        )}
                                        {carousel && (
                                            <div >
                                                {carousel}
                                            </div>
                                        )}
                                        {footerText && (
                                            <div >
                                                {footerText}
                                            </div>
                                        )}

                                        

                                        {(isDownCancelReason != undefined && isDownCancelReason == true) && (
                                            <div>
                                                <>
                                                    <button className="w-full mb-3 border-2 border-[#4B70B980] rounded-full text-white text-[12px] items-center lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold leading-[16px] flex gap-5 p-7 cursor-pointer">
                                                        <div>
                                                            <img
                                                                src={Reasonchecked}
                                                                alt={"Reasonchecked"}
                                                            />
                                                        </div>
                                                        <div>Other</div>
                                                    </button>
                                                    <CustomTextArea
                                                        name={''}
 
                                                        style={{ backgroundColor: '#2c3751', color: '#fff',borderRadius :"0px 10px 0px 10px" }}
                                                        cols={10}
                                                        rows={18}
                                                        value={isDownCancelReasonComments}
                                                        multilineEnabled={true}
                                                        autoFocus={true}
                                                        onChange={(e) => {
                                                            onchangeTextCancelText(e.target.value);
                                                        }}
                                                    />

                                                   {CommnetsValidationError && <div className='text-[#94C3E8] text-[14px]  font-bold flex gap-2 items-center'>
                                                         <div>
                                                            <img src={Oops} alt='Oops' className='ml-2' /></div>{CommnetsValidationError}
                                                        </div>}

                                                    {/* {CommnetsValidationError && displayErrorMessage(CommnetsValidationError)} */}

                                                </>
                                            </div>
                                        )}

                                        {summaryParagraph && (
                                            <div className='w-full flex flex-row '>
                                                {summaryParagraph}
                                            </div>
                                        )}

                                        {subFooter && (
                                            <div className='w-full'>
                                                {subFooter}
                                            </div>
                                        )}

                                    </div>}

                                </div>
                            </div>
                            {/* Footer---- */}
                            {fullWidth ? "" : footerButtonEnable ? "" : allButtonsDisable ? "" : <div className={`md:w-[450px] sm:w-[294px] xsm:w-[240px] w-[240px] flex flex-col justify-start ${gradientButton ? 'mt-1' : props?.borderWhite ? 'mt-1' : 'mt-12'} gap-5`}>
                                {/* <div className='lg:pt-20 md:pt-18 sm:pt-10 pt-16 w-full'> */}
                                <div className='lg:pt-1 md:pt-1 sm:pt-7 w-full mt-[1px]'>
                                    {(btn1Exists && !btn1TypeAcpt) &&
                                        <button onKeyDown={(event) => {
                                            event.target.style.opacity = 0.8;
                                            onAcptBtnClick(); setTimeout(() => { event.target.style.opacity = 1; },
                                                200);
                                            event.stopPropagation();
                                        }} onBlur={() => { setCurrentFocus('') }} onFocus={() => { setCurrentFocus('btn1Ref') }} id='btn1Ref' ref={btn1Ref} style={{ borderColor: props?.btn1BorderColor ? props?.btn1BorderColor : '#2965FB', color: props?.btn1TextColor ? props?.btn1TextColor : '#2965FB' }} className={`w-full border-[2.5px] p-3 font-bold focus:border-black focus:border-[#3px]`} onClick={(event) => { event.target.style.opacity = 0.8; onAcptBtnClick(); setTimeout(() => { event.target.style.opacity = 1; }, 200); }}>{btn1Text}</button>
                                    }
                                    {(btn1Exists && btn1TypeAcpt && !gradientButton) &&
                                        <button
                                            style={{ backgroundColor: props?.btn1BgColor ? props?.btn1BgColor : '#2965FB', borderRadius: props?.btn1BrExist ? 50 : 0, color: props?.btn1TextColor ? props?.btn1TextColor : '#FFFFFF', border: props?.borderWhite ? props?.borderWhite : '' }}
                                            // style={{ backgroundColor:'#2965FB', borderRadius: props?.btn1BrExist ? 50 : 0, color: props?.btn1TextColor ? props?.btn1TextColor : '#FFFFFF', border: props?.borderWhite ? props?.borderWhite :'' }}
                                                      className={`lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] w-full lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold leading-[16px] disabled:opacity-30 ${btn1Text=== t("Extend_Membership") ? "border-2 border-[#30BC89]" : ""}`}
                                            tabIndex={0}
                                            id='btn1AccRef'
                                            onBlur={() => { setCurrentFocus('') }}
                                            onFocus={() => { setCurrentFocus('btn1AccRef') }}
                                            ref={btn1AccRef}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") {
                                                    event.preventDefault();
                                                    onAcptBtnClick();
                                                    event.stopPropagation();
                                                }
                                            }}
                                            onClick={(event) => { event.target.style.opacity = 0.8; onAcptBtnClick(); setTimeout(() => { event.target.style.opacity = 1; }, 200); }}>{btn1Text}</button>

                                    }

                                    {gradientButton &&
                                        <button
                                            style={{
                                                color: props?.btn1TextColor || '#FFFFFF',
                                                background: gradientBtnBackground ? gradientBtnBackground : "",
                                            }}
                                            className={`${!gradientBtnBackground ? borderGradientrouneded ? 'borderGradient md:w-[100%] w-full m-auto' : (gradientBtnCheckExtend?'borderGradientSuqare w-[60%] ml-[5.5rem]': btn1Text=== t("Learn_More") ?  'w-full border-[#30BC89] border-2':'borderGradientSuqare w-full ') : 'w-full'}    font-semibold mt-[40px] flex items-center lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] justify-center lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk leading-[16px] focus:outline-none`}
                                            onClick={(event) => {
                                                event.target.style.opacity = 0.8;
                                                onAcptBtnClick();
                                                setTimeout(() => { event.target.style.opacity = 1; }, 200);
                                            }}
                                        >
                                            {btn1Text}
                                        </button>
                                    }

                                   
                                    {btn2Exists &&
                                        <button
                                            tabIndex={0}
                                            id='btn2Ref'
                                            onBlur={() => { setCurrentFocus('') }}
                                            onFocus={() => { setCurrentFocus('btn2Ref') }}
                                            ref={btn2Ref}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") {
                                                    event.preventDefault();
                                                    onCancelBtnClick();
                                                    event.stopPropagation();
                                                }
                                            }}
                                            className={` w-full mt-5 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] ${isBorderNone ? 'sm:border-0 border-[#2965FB] border-[0px]' : ' border-[#2965FB] border-[2.5px]'} focus:border-[#2965FB] focus:border-[#3px]`}
                                            style={{ color: props?.btn2TextColor ? props?.btn2TextColor : '#4B70B9' }}
                                            onClick={(event) => { event.target.style.opacity = 0.8; onCancelBtnClick(); setTimeout(() => { event.target.style.opacity = 1; }, 200); }}>{btn2Text}</button>
                                    }
                                </div>
                                {/* {(footerMsg && footerMsg != '') &&
                                    <div className='w-full mb-10 md:mb-16'>
                                        {footerMsg}
                                    </div>
                                } */}
                            </div>}

                            {allButtonsDisable ? "" : footerButtonEnable &&
                                <div className="flex sm: justify-between md:gap-[19rem] xsm:gap-[137px] sm:gap-48 mt-[25px]">
                                    <button
                                        type="button"
                                        onClick={(event) => { event.target.style.opacity = 0.8; onCancelBtnClick(); setTimeout(() => { event.target.style.opacity = 1; }, 200); }}
                                        className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[16px] sm:text-[14px] 
                                     text-[#4B70B9] flex items-center"

                                    >
                                        {btn1Text ? btn1Text : t('skip')}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={(event) => { event.target.style.opacity = 0.8; onAcptBtnClick(); setTimeout(() => { event.target.style.opacity = 1; }, 200); }}
                                        className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[16px]
                                      text-white cursor-pointer flex items-center"
                                    >
                                        {btn2Text ? btn2Text : t('next')}<img
                                            src={Arrow}
                                            className="md:w-[9px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[9px]
                                  h-[14px] ml-1"
                                            alt="Arrow" />
                                    </button>

                                </div>}
                        </div>

                    </div>

                </div>
            </div>
        </div >
    );
};

export default CustomModalPlus;